import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointValuesMediaQueries from "@store/Framework/Common/Utilities/breakpointValuesMediaQueries";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    spacerHeight = "spacerHeight",
    hasMobileHeight = "hasMobileHeight",
    mobileHeight = "mobileHeight",
}

interface OwnProps extends WidgetProps {
    extendedStyles?: SpacerStoreStyles;
    fields: {
        [fields.spacerHeight]: number;
        [fields.hasMobileHeight]: boolean;
        [fields.mobileHeight]: number;
    };
}

export interface SpacerStoreStyles {
    spacer?: InjectableCss;
}

export const spacerStoreStyles: SpacerStoreStyles = {
    spacer: {
        css: css`
            display: block;
            width: 100%;
        `,
    },
};

const SpacerStore = ({ extendedStyles, fields }: OwnProps) => {
    const [styles] = React.useState(() => mergeToNew(spacerStoreStyles, extendedStyles));
    const spacerMobileHeight = fields.hasMobileHeight ? fields.mobileHeight : fields.spacerHeight;

    const spacerStyles = {
        css: css`
            ${styles.spacer?.css || ""}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        {
                            values: [`${spacerMobileHeight}px`, null, null, `${fields.spacerHeight}px`, null],
                            properties: ["height"],
                        },
                    ],
                    mediaOptions.min,
                )}
        `,
    };

    return <StyledWrapper {...spacerStyles}></StyledWrapper>;
};

const widgetModule: WidgetModule = {
    component: connect()(SpacerStore),
    definition: {
        group: "Basic",
        displayName: "Spacer",
        icon: "arrows-from-line",
        fieldDefinitions: [
            {
                name: fields.spacerHeight,
                displayName: "Height",
                editorTemplate: "IntegerField",
                defaultValue: 10,
                fieldType: "General",
                min: 0,
                tooltip: "Size will render in px",
            },
            {
                name: fields.hasMobileHeight,
                displayName: "Add Mobile Specific Height",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                isRequired: true,
                variant: "toggle",
            },
            {
                name: fields.mobileHeight,
                displayName: "Mobile Height",
                editorTemplate: "IntegerField",
                defaultValue: 10,
                fieldType: "General",
                min: 0,
                isVisible: item => item?.fields[fields.hasMobileHeight],
            },
        ],
    },
};

export default widgetModule;
